// src/pages/review/AddressInputPage.tsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CancelModal from '../../components/review/CancelModal';
import { useCancelModal } from '../../util/useCancelModal';
import { useReviewAutoSave } from '../../hooks/useReviewAutoSave';
import useReviewStepTracking from '../../hooks/useReviewStepTracking';
import styles from '../../styles/review/AddressInput.module.css';
import closeIcon from '../../assets/image/iconClose.svg';
import searchIcon from '../../assets/image/iconSearch.svg';

const AddressInputPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { housingType } = location.state;

  const {
    showCancelModal,
    handleCloseButtonClick,
    handleCancelModalClose,
    handleConfirmCancel,
  } = useCancelModal();

  // 자동 저장 기능 추가
  useReviewAutoSave('input-address');

  // GA4 Review Funnel Tracking: Step 2
  useReviewStepTracking('2.1_address_input');

  const handleSearchClick = () => {
    navigate('/review/address', { state: location.state });
  };

  return (
    <div className="content">
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill}></div>
          </div>
          <button
            className={styles.closeButton}
            onClick={handleCloseButtonClick}
          >
            <img src={closeIcon} alt="close" />
          </button>
          <h1 className={styles.title}>
            {housingType === "공인중개사"
              ? "공인중개사의 주소를 입력해 주세요!"
              : "주소를 입력해 주세요!"}
          </h1>
        </header>
        <p className={styles.description}>
          {housingType === "공인중개사"
            ? "상호명이나 주소 일부만 입력해도 검색할 수 있어요!"
            : "검색 결과에서 동, 호수까지 확인해주세요"}
        </p>
        <div className={styles.searchBox} onClick={handleSearchClick}>
          <span className={styles.placeholder}>
            {housingType === "공인중개사"
              ? "예) 찐빵공인중개사"
              : housingType === "기숙사"
              ? "예) 찐빵로 47, 찐빵동 122 (찐빵관)"
              : "예) 찐빵로 47, 찐빵동 122"}
          </span>
          <img src={searchIcon} alt="search" className={styles.searchIcon} />
        </div>
      </div>
      <footer className={styles.footer}>
        <button className={styles.prevButton} onClick={() => navigate('/review/type', {
          state: location.state,
          replace: true
        })}>
          이전
        </button>
        <button className={styles.nextButton} disabled={true}>
          다음
        </button>
      </footer>

      {showCancelModal && (
        <CancelModal
          onClose={handleCancelModalClose}
          onConfirm={handleConfirmCancel}
        />
      )}
    </div>
  );
};

export default AddressInputPage;
